import { inject, injectable } from 'tsyringe';
import { type ICompanyUserTokenRepository } from 'application/repositorySchemas/ICompanyUserTokenRepository';
import { type ICompanyEditRepository } from 'application/repositorySchemas/ICompanyEditRepository';
import { type ICompanyEditClient } from 'interfaceAdapter/gatewaySchemas/ICompanyEditClient';
import { type IEditCompanyProfileClient } from 'interfaceAdapter/gatewaySchemas/IEditCompanyProfileClient';
import { type ICompanyUnPublishClient } from 'interfaceAdapter/gatewaySchemas/ICompanyUnPublishClient';
import { type ICompanyReOpenClient } from 'interfaceAdapter/gatewaySchemas/ICompanyReOpenClient';

@injectable()
export class CompanyEditRepository implements ICompanyEditRepository {
    constructor(
        @inject('ICompanyUserTokenRepository')
        public readonly companyUserToken: ICompanyUserTokenRepository,
        @inject('ICompanyEditClient')
        public readonly companyEditClient: ICompanyEditClient,
        @inject('IEditCompanyProfileClient')
        public readonly editCompanyProfileClient: IEditCompanyProfileClient,
        @inject('ICompanyUnPublishClient')
        public readonly companyUnPublishClient: ICompanyUnPublishClient,
        @inject('ICompanyReOpenClient')
        public readonly companyReOpenClient: ICompanyReOpenClient,
    ) {}

    // TODO 型づけをサボっている
    public async edit(company: any) {
        const { data, message } = await this.companyEditClient.post({
            token: this.companyUserToken.get() || '',
            company,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    // TODO 型づけをサボっている
    public async editProfile(company: any) {
        const { data, message } = await this.editCompanyProfileClient.post({
            token: this.companyUserToken.get() || '',
            company,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async unPublish() {
        const { data, message } = await this.companyUnPublishClient.post({
            token: this.companyUserToken.get() || '',
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async reOpen() {
        const { data, message } = await this.companyReOpenClient.post({
            token: this.companyUserToken.get() || '',
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
